import { OrderStatus } from '@api/types';
import { Box, BoxProps, styled } from '@mui/material';

const StyledBox = styled(Box)`
  padding: 4px 8px;
  height: 32px;
  background: #ccc;
  border-radius: 4px;
  margin-top: -4px;
  &.placed {
    background: #afcdff;
  }
  &.processing {
    background: #fff3d3;
  }
  &.delivering {
    background: #deede5;
  }
  &.delivered {
    background: #4d4d4d;
    color: #ffffff;
  }
  &.draft {
    background: #f7f7f7;
  }
  &.postponedelivery {
    background: #b6cfe1;
  }
`;

export type OrderStatusLabelProps = BoxProps & {
  status?: OrderStatus;
};

export const StatusLabel = ({ children, status, ...rest }: OrderStatusLabelProps) => {
  return (
    <StyledBox {...rest} component='span' className={status?.toLowerCase()}>
      {children}
    </StyledBox>
  );
};